import ProductProvider from './ProductContext';
import Product from './Product';


let Index = () => {
    return (
        <ProductProvider>
            <Product />
        </ProductProvider>
    )
}

export default Index;